import { render, staticRenderFns } from "./HeadList.vue?vue&type=template&id=5ae672c9"
import script from "./HeadList.vue?vue&type=script&lang=js"
export * from "./HeadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports